import React, { useState, useEffect } from 'react';
//import './navbar.css';
//import { Link } from "react-router-dom"
import { Table, Button} from 'react-bootstrap';
import axios from "axios";
import Progetto_valutazione_vettore_riga from "./Progetto_valutazione_x1_vettore_radio.jsx";
import { useLocation } from "react-router-dom";
import {QRCodeSVG} from 'qrcode.react';

const { Data_formattata1 } = require('../Funzioni_comuni_data_formattata')


function check_variabili_oggetto(obj, ...args) {
    return args.reduce((obj, level) => obj && obj[level], obj)
}

function isNumber(value) {
    return typeof value === 'number';
  }

const Progetto_valutazione_form_base = (props) => {
//    const [somma, calcola_somma] = useState('');
    const [lista_voti, SET_lista_voti] = useState({});
    const [disabled, SET_disabled] = useState(true);
    const [disabled_pdf, SET_disabled_pdf] = useState(true);
    const [media_voti, SET_media_voti] = useState(-2);
    const search = useLocation().search;
    
    const pdf = new URLSearchParams(search).get('pdf');

// ---------------------------------------------    
    const NUMERO_MASSIMO_DOMANDE = 7 // bisogna cambiare anche due variabili vettore in progetto valutazione x1 vettore radio
// ---------------------------------------------    
 
    useEffect(() => {
        let lista_voti_aux = {}
        let spegni_bottone_pdf = false
        console.log('SSSSSSSSSSSSSSSS')

        console.log(props.progetto)
        if (props.progetto != undefined && props.progetto.valutazione != undefined) {

            props.progetto.valutazione.map(function(element, index, array){
//                console.log('elementt ' + element + ' lista_voti ' )
                if (index < NUMERO_MASSIMO_DOMANDE) {
                    lista_voti_aux = {... lista_voti_aux, [element.indice]: element.voto }
//                    console.log(lista_voti_aux )
                    if (element.voto == -1) {spegni_bottone_pdf = true}
                }
            }, 80);

            SET_disabled_pdf(spegni_bottone_pdf)

        }


        SET_lista_voti(lista_voti_aux)
 
    }, [props.lista_voti, props.progetto]);


    useEffect(() => {
        SET_media_voti(props.progetto.valutazione_media)
    }, [ props.progetto]);





// idroslab e non viene passato    
    const onClick = e => {
        e.persist();
// idroslab
        console.log(lista_voti)
        let lista = lista_voti
        const parametro = {
            progetto_id: props.progetto._id, 
            lista_voti
        }
        axios.put('/progetti/progetto_aggiungi_valutazione/', parametro)
        .then((res) => {
            console.log('Aggiunta valutazione')
            console.log(res.data)
            SET_media_voti(res.data.valutazione_media)
 
        }).catch((error) => {
            console.log(error)
        });
        SET_disabled_pdf(false)
   
        
    };

    const Scarica_pdf = (indirizzo) => {
        const cognome = 'prova'  
       
        axios.get('/progetti/documento_puppeter_pdf_ottieni_url/' + props.progetto._id + '/' + props.progetto.id_alunno.cognome 
                                                                  + '/' + props.progetto.id_alunno.nome + '/valutazione_progetto' )
            .then((res) => {
                console.log('xxxxxxxxxxxxxxxxx url ottenuti dal router')
                console.log(res.data)
                const newWindow = window.open(res.data, '_blank', 'noopener,noreferrer')

                if (newWindow) newWindow.opener = null

                //  return res.data

            }).catch((error) => {
                console.log('ottieni_url url errore')
                console.log(error)
            });
    };


    const argomento1 = "Nome ed uso degli strumenti professionali"
    const argomento2 = "Materiali di uso professionale"
    const argomento3 = "Normativa di sicurezza ed antinfortunistica"
    const argomento4 = "Svolgere semplici compiti che gli sono stati affidati"
    const argomento5 = "Svolgere in autonomia attività professionali"
    const argomento6 = "Lavorare in gruppo"
    const argomento7 = "Dialogare con il cliente / colleghi di aspetti tecnici"


    return (
    <> 


        <div className= 'd-flex flex-row justify-content-between'>
            <div>
        {props.progetto != {} &&  <QRCodeSVG value= {'/#/url_qrcode?doc=P2&id=' + props.progetto._id }/>}
        </div>
        <div>
        {props.progetto != {} && props.progetto.id_ditta != undefined && <>
                    <h4> {props.progetto.id_ditta.ragione_sociale} </h4>
                    <h4> PIVA {props.progetto.id_ditta.partita_iva} </h4>
                    <h4> {props.progetto.id_ditta.ditta_indirizzo_via} {' n. '} {props.progetto.id_ditta.ditta_indirizzo_civico} </h4>
                    
                    <h4> {props.progetto.id_ditta.ditta_indirizzo_citta} </h4>
                    </>}
        </div>
        </div>
        <div >
        <h2> {''} </h2>

        {props.progetto != {} && props.progetto.id_alunno != undefined && <h5>
            L'alunno/a <b> {props.progetto.id_alunno.cognome + ' '}  {props.progetto.id_alunno.nome} </b> della classe: <b> {props.progetto.classe_nome_attuale} </b>
            &emsp; sezione: <b> {props.progetto.classe_nome_sezione_attuale} </b> <p>durante lo stage aziendale svolto nel periodo: <p>
            <b> {Data_formattata1 (props.progetto.data_inizio)} </b> &emsp; a &emsp; <b> {Data_formattata1 (props.progetto.data_fine)} </b>   
            </p> </p>
        </h5> 
        }
        </div>
  
        
        <h2> {''} </h2>

        <h5> Ha dimostrato  le seguenti conoscenze: </h5>  

            <Table striped bordered hover>
        <thead>
        <tr>
            <th>Descrizione</th>
            <th colspan="6">valutazione</th>
          </tr>
        </thead>
            <tbody>                   
        <Progetto_valutazione_vettore_riga   indice_passato='voto1' argomento = {argomento1} SET_disabled={SET_disabled}  SET_lista_voti={SET_lista_voti} lista_voti={lista_voti} progetto={props.progetto} />
        <Progetto_valutazione_vettore_riga   indice_passato='voto2' argomento = {argomento2} SET_disabled={SET_disabled} SET_lista_voti={SET_lista_voti} lista_voti={lista_voti} progetto={props.progetto} />
        <Progetto_valutazione_vettore_riga   indice_passato='voto3' argomento = {argomento3} SET_disabled={SET_disabled} SET_lista_voti={SET_lista_voti} lista_voti={lista_voti} progetto={props.progetto} />
        <td colspan="6">

        <h4> &emsp; </h4>
        <h5> Ha dimostrato le seguenti capacità: </h5>
        </td>
        <tr>
            <th>Descrizione</th>
            <th colspan="6">valutazione</th>
        </tr>
        
        <Progetto_valutazione_vettore_riga   indice_passato='voto4' argomento = {argomento4} SET_disabled={SET_disabled} SET_lista_voti={SET_lista_voti} lista_voti={lista_voti} progetto={props.progetto} />
        <Progetto_valutazione_vettore_riga   indice_passato='voto5' argomento = {argomento5} SET_disabled={SET_disabled} SET_lista_voti={SET_lista_voti} lista_voti={lista_voti} progetto={props.progetto} />
        <Progetto_valutazione_vettore_riga   indice_passato='voto6' argomento = {argomento6} SET_disabled={SET_disabled} SET_lista_voti={SET_lista_voti} lista_voti={lista_voti} progetto={props.progetto} />
        <Progetto_valutazione_vettore_riga   indice_passato='voto7' argomento = {argomento7} SET_disabled={SET_disabled} SET_lista_voti={SET_lista_voti} lista_voti={lista_voti} progetto={props.progetto} />

            </tbody>
        </Table>

        Media Aritmetica {media_voti}

        {!pdf &&  <div className= 'd-flex flex-row-reverse '>
            {pdf}
            <div className= 'd-flex flex-column '>
    
            <Button disabled={disabled} onClick={onClick}>
                Salva 
            </Button> 

            <Button  disabled={disabled_pdf || true} onClick={Scarica_pdf}>
                Scarica PDF per Timbro e firma
            </Button>
            </div>
 
        </div>}
        {pdf &&  <div className= 'd-flex flex-row-reverse '> 
        <div className= 'd-flex flex-column'>
            
            <p>Firma e Timbro Ditta</p> <p><p></p><p></p>
                _____________________
            </p>
        </div>
        </div>
        }

    </>
    )
}
export default Progetto_valutazione_form_base;